import React from "react";
import { Box, Card, Typography, Chip, Divider } from "@mui/material";
import { formatAmount } from "../../../../utils/hooks/dataHandler";

const HpDetails = ({ assets }) => {
  return (
    <Box sx={{ p: 2 }}>
      {assets?.length > 0 ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {assets.map((asset) => (
            <Card key={asset.assetId} variant='outlined' sx={{ p: 2 }}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                {/* Asset Name */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant='subtitle2' color='text.secondary'>
                    Asset:
                  </Typography>
                  <Typography variant='body1' sx={{ fontWeight: "medium" }}>
                    {asset.assetName}
                  </Typography>
                </Box>

                {/* Amount */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant='subtitle2' color='text.secondary'>
                    Amount:
                  </Typography>
                  <Typography
                    variant='body1'
                    sx={{ fontWeight: "medium", color: "primary.main" }}
                  >
                    ${formatAmount(asset.amount)}
                  </Typography>
                </Box>

                {/* Disposal Status */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant='subtitle2' color='text.secondary'>
                    Status:
                  </Typography>
                  <Chip
                    label={asset.isDisposed ? "Disposed" : "Active"}
                    size='small'
                    color={asset.isDisposed ? "error" : "success"}
                    variant='outlined'
                  />
                </Box>
              </Box>
            </Card>
          ))}

          {/* Summary */}
          <Divider sx={{ my: 1 }} />
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant='subtitle1' sx={{ fontWeight: "bold" }}>
              Total Assets:
            </Typography>
            <Typography
              variant='h6'
              color='primary.main'
              sx={{ fontWeight: "bold" }}
            >
              $
              {formatAmount(
                assets.reduce((total, asset) => total + asset.amount, 0)
              )}
            </Typography>
          </Box>
        </Box>
      ) : (
        <Box sx={{ textAlign: "center", py: 4 }}>
          <Typography variant='body2' color='text.secondary'>
            No hire purchase assets found
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default HpDetails;
